import axios from 'axios';
import { setAutoRedirectToNias } from 'app/shared/reducers/keycloak';
import {
  AUTH_TOKEN_KEY,
  KEYCLOAK_ID_TOKEN,
  successLogin,
  USER_ROLE_KEY
} from 'app/shared/reducers/authentication';
import jwt from 'jwt-decode';
import cleanLocalStorage, {clearLocalStorageExceptPendingAuthentication} from 'app/shared/util/local-storage-keys';
import Keycloak from 'keycloak-js';
import { IUser, JWTUser } from 'app/shared/model/user.model';
import { AUTHORITIES } from 'app/config/constants';
import { Storage } from 'react-jhipster';

let keycloak = new Keycloak();

export const initKeycloak = dispatch => {
  return new Promise<void>((resolve, reject) => {
    axios
      .get('api/keycloak-properties')
      .then(response => {

        // Ako je osoba vec ulogirana, ne radi se KC inicijalizacija
        // -inicijalizacija se radi samo kad osoba nije ulogirana, jer nam kc instanca treba samo za login, logout se
        //  radi redirectom korisnika na KC logout url
        const keycloakToken = Storage.local.get(KEYCLOAK_ID_TOKEN);
        const authenticationToken = Storage.local.get(AUTH_TOKEN_KEY);
        if (keycloakToken != null && authenticationToken !== undefined) {
          mapAndDispatchUser(dispatch, authenticationToken);
          resolve();
          return;
        }

        keycloak = new Keycloak({
          url: response.data.keycloakUrl,
          realm: response.data.keycloakRealm,
          clientId: response.data.keycloakClientId,
        });

        localStorage.removeItem(USER_ROLE_KEY);
        dispatch(setAutoRedirectToNias({ autoRedirectToNias: response.data.autoRedirectToNias }));

        keycloak
          .init({ onLoad: 'check-sso' })
          .then(auth => {
            if (auth) {
              axios
                .post('api/authenticate', {
                  keycloakToken: keycloak.token,
                  keycloakRefreshToken: keycloak.refreshToken,
                })
                .then(res => {
                  clearLocalStorageExceptPendingAuthentication();
                  resolveSuccessfulAuthentication(res, dispatch);
                  resolve();
                })
                .catch(reject);
            } else {
              axios
                .post('api/authenticate-public-user')
                .then(res => {
                  localStorage.setItem(USER_ROLE_KEY, AUTHORITIES.NEPRIJAVLJENI);
                  resolveSuccessfulAuthentication(res, dispatch);
                  resolve();
                })
                .catch(reject);
            }
          })
          .catch(reject);
      })
      .catch(reject);
  });
};

const resolveSuccessfulAuthentication = (res: any, dispatch: any) => {
  clearLocalStorageExceptPendingAuthentication();
  const bearerToken = res.headers.authorization;
  const token = bearerToken.slice(7, bearerToken.length);

  localStorage.setItem(KEYCLOAK_ID_TOKEN, keycloak.idToken);
  localStorage.setItem(AUTH_TOKEN_KEY, token);

  mapAndDispatchUser(dispatch, token);
};

function mapAndDispatchUser(dispatch, token) {
  const user: JWTUser = jwt(token);
  const iuser: IUser = {
    id: user.idUser,
    firstName: user.firstName,
    lastName: user.lastName,
    authorities: user.authorities,
    userSelected: user.userSelected,
    szIsZastupanje: user.szIsZastupanje,
    szIpsRegistar: user.szIpsRegistar,
    szIps: user.szIps,
    szSubjectOfRepresentationSelected: user.szSubjectOfRepresentationSelected,
    mandate: user.mandate
  };

  dispatch(successLogin(iuser));
}

export function fetchAndLogoutKeycloak() {
  axios.get('api/keycloak-properties').then(response => {
    const keycloakToken = Storage.local.get(KEYCLOAK_ID_TOKEN);
    let url = response.data.keycloakLogoutUrl
      + "?client_id=" + response.data.keycloakClientId
      + "&post_logout_redirect_uri=" + window.location.origin;

    if (keycloakToken) {
      url += "&id_token_hint=" + keycloakToken;
    }

    cleanLocalStorage();
    window.location.href = url;
  });
}

export function useKeycloak() {
  return keycloak;
}
